import React from 'react';
import IlosRecording from './IlosRecording';
import IlosVideo from '../../IlosVideo';

export default class IlosVideoEmbed extends React.Component {
  constructor(props) {
    super(props);
    this.determineEmbed = this.determineEmbed.bind(this);
  }

  determineEmbed() {
    if (this.props.recording) {
      return <IlosRecording {...this.props} />;
    }
    return (
      <IlosVideo
        i18n={this.props.i18n}
        randtag={this.props.givenAnswer}
        lessonTaking
        loadIlosRecording={this.props.loadIlosRecording}
        finished={this.props.finished}
      />
    );
  }

  render() {
    return <div className="IlosVideoEmbed">{this.determineEmbed()}</div>;
  }
}
